import { useEffect } from 'react'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import { twMerge } from 'tailwind-merge'
import { motion } from 'framer-motion'

const notificationTypes = {
  error: 'bg-red-600',
  success: 'bg-[#D4AF37]',
  info: 'bg-cyan-400',
}
export type NotificationProps = {
  title: string
  message: string
  type?: keyof typeof notificationTypes
  handleClose: () => void
}
export const Notification = ({
  message,
  title,
  type = 'info',
  handleClose,
}: NotificationProps) => {
  useEffect(() => {
    const timeOut = setTimeout(() => {
      handleClose()
    }, 3000)
    return () => clearTimeout(timeOut)
  }, [])
  return (
    <motion.div
      initial={{ x: '110%' }}
      animate={{ x: '0' }}
      exit={{ x: '110%' }}
      transition={{ type: 'tween', duration: 0.5 }}
      className={twMerge(
        `relative pointer-events-auto flex w-4/5 md:max-w-[300px]  flex-col gap-y-2 rounded-lg  p-4 font-nunito text-white shadow-md`,
        notificationTypes[type]
      )}
    >
      <IoIosCloseCircleOutline
        onClick={handleClose}
        className="absolute right-5 top-5 cursor-pointer"
        size={20}
      />

      <h2 className="text-base font-bold">{title}</h2>
      <p className="text-sm">{message}</p>
    </motion.div>
  )
}
